<template>

  <b-card no-body class=" shadow  ">

    <b-row no-gutters class="">
      <b-col xl="6" lg="6" md="12" sm="12" class="m-0 p-0">
        <a href="javascript:void(0)" @click="open(food.raw_link)">
          <b-card-img
              :src="food.thumbnail"
              :alt="food.name"
              class="h-100 w-100"
          ></b-card-img>
        </a>
      </b-col>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card-body class="w-100 h-100">
          <b-row class="pt-2 w-100">
            <b-col cols="12">
              <a href="javascript:void(0)" @click="open(food.raw_link)">
                <h3 class="secondary-text">{{ food.name }}</h3>
              </a>
            </b-col>
          </b-row>
          <b-row class="text-dark">
            <p v-if="food.description.length<80" v-html="food.description"/>
            <p v-else v-html="food.description"/>
          </b-row>
          <b-row class="flag w-100">
            <span>{{ getFormattedNumber(food.price) }} تومان</span>
          </b-row>

          <b-container v-if="foodActive===true && restaurantActive===true">
            <b-row v-if="!checkOrder(food)" class="p-2">

              <b-button class="add-to-shopping-card bg-success rounded text-dark" @click="addToOrder(food, basket)">
                <b-icon icon="plus"/>
              </b-button>

            </b-row>
            <b-row v-else>
              <span class="text-dark">به سفارش اضافه شده</span>
            </b-row>

            <b-row class="d-flex flex-row justify-content-center p-3" v-if="checkOrder(food)">
              <b-button class="q-link border-0 m-1 p-1" @click="addToOrder(food, basket)">+
              </b-button>

              <span class="m-1 px-2 py-2 q-link bg-light rounded text-dark">{{ getQuantity(food.id) }}</span>

              <b-button class="q-link border-0 m-1 p-1"
                        @click="changeItemQuantity(food, getQuantity(food.id), basket)"
                        v-if="getQuantity(food.id)>1">-
              </b-button>

              <b-button class="rounded  " variant="transparent" @click="removeFromOrder(food, basket)">
                <b-icon variant="danger" class="mb-1" icon="cart-x-fill"/>
              </b-button>
            </b-row>
          </b-container>

          <b-container v-else>
            <b-row>
              <b-col v-if="restaurantActive===false">
                <span>در حاضر رستوران بسته است</span>
              </b-col>
              <b-col v-else>
                <span>زمان سفارش این غذا به پایان رسیده</span>
              </b-col>
            </b-row>
          </b-container>

        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: "CardContainer",
};
</script>
<style scoped>


.col {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.food-title {
  text-align: center;
}

.flag {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  height: 40px;
  position: relative;
  right: -20px;
  background: var(--secondary);
  color: white;
  text-align: center;
  font-size: 25px;
}

.flag:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}

.flag:before {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 20px solid var(--secondary);
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}

.q-link {
  height: 25px;
  line-height: 10px;
  background-color: var(--secondary);
  color: var(--light);
}


.card-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.card {
  border: none;
  transition: all .3s ease-in-out;
}

.card:hover {
  transform: scale(0.95);
  transition: all .3s ease-in-out;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .12), 0 4px 8px rgba(0, 0, 0, .06);
}

.add-to-shopping-card{
  color: var(--dark);
  border: none;
}

</style>